<template>
  <div class="main" :class="{ 'main-hide-text': shrink }">
    <div
      class="sidebar-menu-con"
      :style="{ width: shrink ? '60px' : menuWidth, background: bgColor }"
    >
      <shrinkable-menu
        ref="shrinkableMenu"
        :shrink="shrink"
        @on-change="handleSubmenuChange"
        :theme="menuTheme"
        :before-push="beforePush"
        :open-names="openedSubmenuArr"
        :menu-list="menuList"
      >
        <div slot="top" class="logo-con">
          <div class="logo-img-wrap">
            <img v-show="!shrink" :src="logoPath" key="min-logo" />
            <p class="showP">机动车排放治理信息管理系统</p>
          </div>
          <!--<img v-show="!shrink" src="/static/images/logo.png" key="max-logo"/>-->
        </div>
      </shrinkable-menu>
    </div>
    <div
      class="main-header-con"
      :style="{ paddingLeft: shrink ? '60px' : menuWidth }"
    >
      <div class="main-header">
        <!--<div class="navicon-con">-->
        <!--<Button :style="{transform: 'rotateZ(' + (this.shrink ? '-90' : '0') + 'deg)'}" type="text"-->
        <!--@click="toggleClick">-->
        <!--<Icon type="navicon" size="32"></Icon>-->
        <!--</Button>-->
        <!--</div>-->
        <!--<div class="header-middle-con">-->
        <!--<div class="main-breadcrumb">-->
        <!--<breadcrumb-nav :currentPath="currentPath"></breadcrumb-nav>-->
        <!--</div>-->
        <!--</div>-->
        <div class="header-avator-con">
          <!--<full-screen v-model="isFullScreen" @on-change="fullscreenChange"></full-screen>-->
          <MessageTip></MessageTip>
          <div class="user-dropdown-menu-con">
            <Row
              type="flex"
              justify="end"
              align="middle"
              class="user-dropdown-innercon"
            >
              <!--              <div style="margin-right: 25px">-->
              <!--                <message-tip v-model="mesCount"></message-tip>-->
              <!--              </div>-->
              <Dropdown
                transfer
                trigger="hover"
                @on-click="handleClickUserDropdown"
              >
                <Avatar
                  :src="avatorPath"
                  style="background-color: #ffffff"
                ></Avatar>
                <a href="javascript:void(0)">
                  <span class="main-user-name">{{ userName }}</span>
                  <Icon type="arrow-down-b" style="color: black"></Icon>
                </a>
                <DropdownMenu slot="list">
                  <DropdownItem name="ownSpace"
                    ><span
                      class="iconfont iconchangepassword"
                      style="font-size: 14px"
                      ><span :style="userActionStyle">修改密码</span></span
                    ></DropdownItem
                  >
                  <DropdownItem name="logout" divided
                    ><span class="iconfont iconexit" style="font-size: 14px"
                      ><span :style="userActionStyle">退出</span></span
                    ></DropdownItem
                  >
                </DropdownMenu>
              </Dropdown>
            </Row>
          </div>
        </div>
      </div>
      <div class="tags-con">
        <tags-page-opened :pageTagsList="pageTagsList"></tags-page-opened>
      </div>
    </div>
    <div class="tag-shadow-fixed" :class="{ 'tag-shadow': isTagsShadow }">
      &nbsp;
    </div>
    <MessageScrolling></MessageScrolling>
    <div
      id="single-page-con"
      class="single-page-con"
      :style="{ left: shrink ? '60px' : menuWidth }"
    >
      <div class="single-page">
        <keep-alive :include="cachePage">
          <router-view></router-view>
        </keep-alive>
      </div>
    </div>
    <!--初始密码校验-->
    <ModalCustom
      :model="isDefaultPwd"
      :width="380"
      :hide-header-line="true"
      :ok-text="'是'"
      :cancel-text="'否'"
      :ok-class="'btn-fill-34 width-60'"
      :cancel-class="'btn-border-34 width-60'"
      @on-ok="changePwd"
      @on-cancel="isDefaultPwd = false"
    >
      <p slot="body" class="modal-body-content">
        系统校验到您的密码为初始密码，存在安全隐患是否前往修改？
      </p>
    </ModalCustom>
    <!--修改密码-->
    <UserPasswordEdit
      :model="userEditModal"
      @cancelEdit="cancelEdit"
    ></UserPasswordEdit>
    <!--登出-->
    <ModalCustom
      :model="loginoutModel"
      :title="'确认退出'"
      :width="380"
      :hide-header-line="true"
      :ok-class="'btn-fill-34 width-60'"
      :cancel-class="'btn-border-34 width-60'"
      @on-ok="loginoutbto"
      @on-cancel="loginoutModel = false"
    >
      <p slot="body" class="modal-body-content">确定要退出平台吗？</p>
    </ModalCustom>
  </div>
</template>
<script>
import api from '@/api'
import shrinkableMenu from './components/shrinkable-menu/shrinkable-menu.vue'
import tagsPageOpened from './components/tags-page-opened.vue'
import breadcrumbNav from './components/breadcrumb-nav.vue'
import fullScreen from './components/fullscreen.vue'
import MessageTip from './components/message.vue'
import MessageScrolling from './components/message-scrolling.vue'
import util from '@/libs/util'
import { mapMutations, mapState } from 'vuex'
import ModalCustom from './components/modal-custom/index'
import UserPasswordEdit from './gip/account/editUserInfo.vue'
export default {
  name: 'Main',
  components: {
    shrinkableMenu,
    tagsPageOpened,
    breadcrumbNav,
    fullScreen,
    MessageTip,
    MessageScrolling,
    ModalCustom,
    UserPasswordEdit
  },
  data() {
    return {
      isDefaultPwd: false,
      shrink: false,
      userName: '',
      isFullScreen: false,
      openedSubmenuArr: this.$store.state.app.openedSubmenuArr,
      userEditModal: false,
      loginoutModel: false,
      menuWidth: '270px',
      shadowNode: {},
      scrollNode: {},
      isTagsShadow: false // 顶部是否显示阴影
    }
  },
  computed: {
    ...mapState('user', ['user']),
    menuList() {
      return this.$store.state.app.menuList
    },
    pageTagsList() {
      return this.$store.state.app.pageOpenedList // 打开的页面的页面对象
    },
    currentPath() {
      return this.$store.state.app.currentPath // 当前面包屑数组
    },
    avatorPath() {
      // return this.user.avatar
      // 当前版本用同一个头像
      return '../../static/images/loginuser.png'
    },
    cachePage() {
      return this.$store.state.app.cachePage
    },
    lang() {
      return this.$store.state.app.lang
    },
    menuTheme() {
      return this.$store.state.app.menuTheme
    },
    bgColor() {
      return this.menuTheme === 'dark' ? '#313557' : '#313557'
    },
    userActionStyle() {
      return {
        marginLeft: '10px',
        fontSize: '14px',
        fontWeight: 500,
        color: '#333333'
      }
    },
    logoPath() {
      const { host } = window.location;
      if (host.indexOf('yame') > -1) {
        return '/static/images/yame_logo.png'
      }
      return '/static/images/logo.png';
    }
  },
  methods: {
    ...mapMutations('user', ['setUser', 'logout']),
    init() {
      this.loadStorageData()
      let pathArr = util.setCurrentPath(this, this.$route.name)
      this.$store.commit('updateMenulist', this.user)
      if (pathArr.length >= 2) {
        this.$store.commit('addOpenSubmenu', pathArr[1].name)
      }
      this.userName = this.user.name
      this.getStoreDetail(this.user.orgId)
      this.checkTag(this.$route.name)
      this.onResize()
    },
    toggleClick() {
      this.shrink = !this.shrink
      this.$store.commit('changeShrink', this.shrink)
    },
    changePwd() {
      this.isDefaultPwd = false
      this.userEditModal = true
    },
    handleClickUserDropdown(name) {
      if (name === 'ownSpace') {
        this.userEditModal = true
      } else if (name === 'logout') {
        this.loginoutModel = true
      }
    },
    loginoutbto() {
      // 退出登录
      this.logout(this)
      this.$store.dispatch('logout')
      this.$router.push({
        name: 'login'
      })
      this.$Message.success('退出成功')
    },
    checkTag(name) {
      let openpageHasTag = this.pageTagsList.some(item => {
        if (item.name === name) {
          return true
        }
      })
      if (!openpageHasTag) { //  解决关闭当前标签后再点击回退按钮会退到当前页时没有标签的问题
        util.openNewPage(this, name, this.$route.params || {}, this.$route.query || {})
      }
    },
    handleSubmenuChange(val) {
      // console.log(val)
    },
    beforePush(name) {
      // if (name === 'accesstest_index') {
      //     return false;
      // } else {
      //     return true;
      // }
      return true
    },
    loadStorageData() {
      // 加载localStorage中的数据
      const user = JSON.parse(localStorage.getItem('user')) || {}
      this.setUser(user)
    },
    fullscreenChange(isFullScreen) {
      // console.log(isFullScreen);
    },
    scrollBarResize() {
      this.$refs.shrinkableMenu.resize()
    },
    cancelEdit() {
      this.userEditModal = false
    },
    onResize() {
      let screen = document.body.clientWidth
      let width = screen * 0.14
      if (width < 200) {
        this.menuWidth = '200px'
      } else if (width > 270) {
        this.menuWidth = '270px'
      } else {
        this.menuWidth = width.toFixed(2) + 'px'
      }
      this.$store.commit('changeMenuWidth', this.menuWidth)
      this.$store.commit('changeScreenWidth', screen)
    },
    initShadow() {
      this.shadowNode = document.getElementById('single-page-con').firstElementChild
      this.scrollNode = document.getElementById('single-page-con')
      this.scrollNode.addEventListener('scroll', this.handleScroll)
    },
    destoryShadow() {
      this.scrollNode.removeEventListener('scroll', this.handleScroll)
    },
    handleScroll() {
      let toTop = this.shadowNode.getBoundingClientRect().top
      if (!this.isTagsShadow && toTop <= 120) {
        this.isTagsShadow = true
      } else if (this.isTagsShadow && toTop > 120) {
        this.isTagsShadow = false
      }
    },
    // 当前登录所属区域
    getStoreDetail(orgId) {
      api.user.storeDetail(orgId).then(resp => {
        let result = resp.data
        if (result.code === '0000' && result.data) {
          let cityCode = result.data.cityCode
          this.$store.dispatch('user/setCityCode', cityCode)
        }
      })
    }
  },
  watch: {
    '$route'(to) {
      this.$store.commit('setCurrentPageName', to.name)
      let pathArr = util.setCurrentPath(this, to.name)
      if (pathArr.length > 2) {
        this.$store.commit('addOpenSubmenu', pathArr[1].name)
      }
      this.checkTag(to.name)
      localStorage.currentPageName = to.name
    },
    lang() {
      util.setCurrentPath(this, this.$route.name) // 在切换语言时用于刷新面包屑
    },
    openedSubmenuArr() {
      setTimeout(() => {
        this.scrollBarResize()
      }, 300)
    }
  },
  mounted() {
    this.isDefaultPwd = !!this.$route.params.isDefaultPwd
    this.initShadow()
    this.init()
    // window.addEventListener('resize', this.scrollBarResize)
    // TODO: sidebar宽度改变，可能会影响ops-fit
    window.addEventListener('resize', this.onResize)
  },
  created() {
    // 显示打开的页面的列表
    this.$store.commit('setOpenedList')
  },
  beforeDestroy() {
    this.destoryShadow()
  },
  dispatch() {
    // window.removeEventListener('resize', this.scrollBarResize)
    window.removeEventListener('resize', this.this.onResize)
  }
}
</script>

<style lang="less">
@import "../styles/main.less";
</style>

<style lang="less" scoped>
@import "../styles/_common/components/index.less";

.modal-body-content {
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  color: #666666;
}
.logo-img-wrap {
  display: flex;
  justify-content: flex-start;
  width: 500px;
}
</style>



// WEBPACK FOOTER //
// src/views/main.vue